import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Table, Badge, Card, Row, Col } from "react-bootstrap";
import Pagination from 'react-js-pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUser, faEnvelope, faPhone, faMapMarkerAlt, faCalendarAlt, faTrash, faCheckCircle, faBan, faUserEdit } from '@fortawesome/free-solid-svg-icons';

import ViewItemsPerPage from "../ViewItemsPerPage";

interface ListUsersProps {
  usersList: any[];
  usersListCount: number;
  usersListPageIndex: number;
  usersListPageSize: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
  findOptions: any;
  handleFindUser: (findOptions: any) => void;
  resetFindOptions: () => void;
  toggleActivation: (userId: number, userDetails: any) => void;
  onDeleteUser: (userId: number) => void;
}

const ListUsers: React.FC<ListUsersProps> = ({
  usersList,
  usersListCount,
  usersListPageIndex,
  usersListPageSize,
  onChangePageIndex,
  onChangePageSize,
  findOptions,
  handleFindUser,
  resetFindOptions,
  toggleActivation,
  onDeleteUser,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState(findOptions);

  const handleModalClose = () => setShowModal(false);
  const handleModalOpen = () => setShowModal(true);

  const onChangeFieldValue = (value: object) => {
    setSearchOptions({ ...searchOptions, ...value });
  }
  const onClickFind = (findOptions: any) => {
    handleFindUser(findOptions);
    handleModalClose();
  };

  useEffect(() => { setSearchOptions(findOptions) }, [findOptions])

  return (
    <div className="customer-list-container">
      <style>{`
        .customer-list-container {
          font-family: 'Inter', system-ui, -apple-system, sans-serif;
        }
        .modern-card {
          border: none;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          background: #fff;
          overflow: hidden;
        }
        .modern-table {
          margin-bottom: 0;
        }
        .modern-table thead th {
          background-color: #f8f9fa;
          color: #495057;
          font-weight: 700;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 2px solid #e9ecef;
          padding: 1rem;
        }
        .modern-table tbody td {
          padding: 1rem;
          vertical-align: middle;
          border-bottom: 1px solid #f1f3f5;
        }
        .user-avatar {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          background: linear-gradient(135deg, #198754 0%, #20c997 100%);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          margin-right: 15px;
          box-shadow: 0 4px 10px rgba(32, 201, 151, 0.3);
          flex-shrink: 0;
        }
        .icon-btn {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
        }
        .icon-btn:hover {
          transform: translateY(-2px);
        }
        @media (max-width: 768px) {
          .modern-table thead {
            display: none;
          }
          .modern-table tbody, .modern-table tr, .modern-table td {
            display: block;
            width: 100%;
          }
          .modern-table tr {
            margin-bottom: 1rem;
            border: 1px solid #e9ecef;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.04);
            background: #fff;
          }
          .modern-table td {
            text-align: right;
            padding-left: 40%;
            position: relative;
            border-bottom: 1px solid #f8f9fa;
          }
          .modern-table td::before {
            content: attr(data-label);
            position: absolute;
            left: 1rem;
            width: 35%;
            padding-right: 10px;
            white-space: nowrap;
            text-align: left;
            font-weight: 600;
            color: #6c757d;
            font-size: 0.85rem;
          }
          .modern-table td:last-child {
            border-bottom: 0;
            display: flex;
            justify-content: flex-end;
            gap: 10px;
          }
          .user-avatar-wrapper {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 100%;
          }
        }
        @media (min-width: 769px) {
          .user-avatar-wrapper {
            display: flex;
            align-items: center;
          }
        }
      `}</style>

      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div>
          <h4 className="fw-bold mb-1" style={{ color: '#2d3748' }}>Customer Directory</h4>
          <p className="text-muted mb-0 small">Manage your registered customers efficiently.</p>
        </div>
        <Button variant="primary" className="shadow-sm rounded-pill px-4" onClick={handleModalOpen} style={{ background: 'linear-gradient(135deg, #198754 0%, #20c997 100%)', border: 'none' }}>
          <FontAwesomeIcon icon={faSearch} className="me-2" /> Find Options
        </Button>
      </div>

      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">Find Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="find-customer-id">
              <Form.Label className="small fw-semibold text-muted">CUSTOMER ID</Form.Label>
              <Form.Control
                type="text"
                className="rounded-3"
                value={searchOptions.userId ? searchOptions.userId : ''}
                onChange={(e) => onChangeFieldValue({ userId: parseInt(e.target.value) })}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="find-full-name">
              <Form.Label className="small fw-semibold text-muted">NAME</Form.Label>
              <Form.Control
                type="text"
                className="rounded-3"
                value={searchOptions.name ? searchOptions.name : ''}
                onChange={(e) => onChangeFieldValue({ name: e.target.value })}
              />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="find-email">
                  <Form.Label className="small fw-semibold text-muted">EMAIL</Form.Label>
                  <Form.Control
                    type="email"
                    className="rounded-3"
                    value={searchOptions.email ? searchOptions.email : ''}
                    onChange={(e) => onChangeFieldValue({ email: e.target.value })}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="find-mobile">
                  <Form.Label className="small fw-semibold text-muted">MOBILE</Form.Label>
                  <Form.Control
                    type="text"
                    className="rounded-3"
                    value={searchOptions.mobile ? searchOptions.mobile : ''}
                    onChange={(e) => onChangeFieldValue({ mobile: e.target.value })}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="light" className="rounded-pill px-4" onClick={() => resetFindOptions()}>Clear</Button>
          <Button variant="success" className="rounded-pill px-4 shadow-sm" onClick={() => onClickFind(searchOptions)}>Apply Search</Button>
        </Modal.Footer>
      </Modal>

      <Card className="modern-card mb-4">
        <div className="table-responsive">
          <Table className="modern-table" hover>
            <thead>
              <tr>
                <th style={{ width: '80px' }}>ID</th>
                <th>Customer</th>
                <th>Contact Details</th>
                <th>Demographics</th>
                <th>Location</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {usersList.map((user) => (
                <tr key={user.userId}>
                  <td data-label="ID" className="fw-bold text-success" style={{ fontSize: '1.05rem' }}>#{user.userId}</td>
                  <td data-label="Customer">
                    <div className="user-avatar-wrapper">
                      <div className="user-avatar">
                        <FontAwesomeIcon icon={faUser} />
                      </div>
                      <div className="text-md-start">
                        <div className="fw-bold" style={{ color: '#2d3748', fontSize: '1.05rem' }}>
                          {[user.firstName, user.middleName, user.lastName].filter(Boolean).join(" ")}
                        </div>
                        {user.isActive ? 
                          <Badge bg="success" className="rounded-pill mt-2 px-3 py-2 fw-bold text-white" style={{ fontSize: '0.9rem' }}>Active</Badge> : 
                          <Badge bg="secondary" className="rounded-pill mt-2 px-3 py-2 fw-bold text-white" style={{ fontSize: '0.9rem' }}>Inactive</Badge>
                        }
                      </div>
                    </div>
                  </td>
                  <td data-label="Contact">
                    <div className="d-flex flex-column text-md-start">
                      <div className="text-dark fw-bold mb-1" style={{ fontSize: '1rem' }}>
                        <FontAwesomeIcon icon={faEnvelope} className="me-2 text-success" style={{ width: '18px' }} />
                        {user.email || 'N/A'}
                      </div>
                      <div className="text-dark fw-bold" style={{ fontSize: '1rem' }}>
                        <FontAwesomeIcon icon={faPhone} className="me-2 text-success" style={{ width: '18px' }} />
                        {user.countryCode} {user.mobile || 'N/A'}
                      </div>
                    </div>
                  </td>
                  <td data-label="Demographics">
                    <div className="d-flex flex-column text-md-start">
                      <div className="text-dark fw-bold mb-1 text-capitalize" style={{ fontSize: '1rem' }}>
                        <FontAwesomeIcon icon={faUserEdit} className="me-2 text-info" style={{ width: '18px' }} />
                        {user.gender || 'N/A'}
                      </div>
                      <div className="text-dark fw-bold" style={{ fontSize: '1rem' }}>
                        <FontAwesomeIcon icon={faCalendarAlt} className="me-2 text-warning" style={{ width: '18px' }} />
                        {user.dob ? new Date(user.dob).toLocaleDateString() : 'N/A'}
                      </div>
                    </div>
                  </td>
                  <td data-label="Location">
                    <div className="text-dark fw-bold text-md-start" style={{ fontSize: '1rem' }}>
                       <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-danger" style={{ width: '18px' }} /> 
                       {user.city ? `${user.city}, ${user.state}` : 'N/A'}
                    </div>
                  </td>
                  <td data-label="Actions" className="text-center">
                    <div className="d-flex justify-content-end justify-content-md-center gap-2">
                      <Button
                        variant={user.isActive ? "outline-warning" : "outline-success"}
                        className="icon-btn border-0 shadow-sm"
                        title={user.isActive ? "Deactivate User" : "Activate User"}
                        onClick={() => toggleActivation(user.userId, { ...user, isActive: !user.isActive })}
                      >
                        <FontAwesomeIcon icon={user.isActive ? faBan : faCheckCircle} />
                      </Button>
                      <Button
                        variant="outline-danger"
                        className="icon-btn border-0 shadow-sm"
                        title="Delete User"
                        onClick={() => onDeleteUser(user.userId)}
                      >
                        <FontAwesomeIcon icon={faTrash as any} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
              {usersList.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center py-5 text-muted">
                    No customers found matching your criteria.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card>
      
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center bg-white p-3 rounded-3 shadow-sm mb-4">
        <ViewItemsPerPage
          selectedPageSize={usersListPageSize}
          onSelectPageSize={onChangePageSize}
        />
        <div className="mt-3 mt-md-0">
          <Pagination
            activePage={usersListPageIndex + 1}
            totalItemsCount={usersListCount}
            itemsCountPerPage={usersListPageSize}
            onChange={onChangePageIndex}
            itemClass="page-item"
            linkClass='page-link shadow-none'
            firstPageText="First"
            lastPageText="Last"
          />
        </div>
      </div>
    </div>
  );
};

export default ListUsers;
